import { render, staticRenderFns } from "./CustomersCreateEdit.vue?vue&type=template&id=39356787&"
import script from "./CustomersCreateEdit.vue?vue&type=script&lang=js&"
export * from "./CustomersCreateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports